import React, { Component } from 'react';
import Select from '@mui/material/Select';
import OutlinedInput from '@mui/material/OutlinedInput';
import LinearProgress from '@mui/material/LinearProgress';

class DelayedSelect extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      forceSelectAll: true,
      selectValue: 'all',
      list: [],
    };
    this.selectValue = this.selectValue.bind(this);
  }
  componentDidMount() {
    var apiURL = '';
    if (this.props.type === 'providers' && this.props.account_override !== undefined) {
      apiURL = '/api/providers/active/' + this.props.account_override;
    } else if (this.props.type === 'providers') {
      apiURL = '/api/providers/active/';
    } else if (this.props.type === 'appointment_types' && this.props.account_override !== undefined) {
      apiURL = '/api/appointment_types/' + this.props.account_override;
    } else if (this.props.type === 'appointment_types' || this.props.type === 'virtual_visits') {
      apiURL = '/api/appointment_types/';
    } else if (this.props.type === 'cancellation_reasons' && this.props.account_override !== undefined) {
      apiURL = '/api/cancellation_reasons/' + this.props.account_override;
    } else if (this.props.type === 'cancellation_reasons') {
      apiURL = '/api/cancellation_reasons/';
    } else {
      apiURL = '/api/' + this.props.type;
    }
    // console.log(apiURL);
    return fetch(apiURL, { cache: 'no-store' })
      .then((response) => response.json())
      .then((responseJson) => {
        const data = responseJson.api;
        if (data) {
          this.setState({ loading: false, list: data });
        } else {
          //logged out
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }
  componentWillReceiveProps(props) {
    if (props.user_role !== this.state.user_role) {
      this.setState({ user_role: props.user_role });
    }

    if (props.forceSelectAll !== this.state.forceSelectAll) {
      if (props.forceSelectAll == true) {
        var value = this.state.list.map(function (a) {
          return a.id;
        });
        this.setState({ selectValue: value });
        this.props.passUp(this.props.type, value);
      }
      this.setState({ forceSelectAll: props.forceSelectAll });
    }
  }
  selectValue(v) {
    this.setState({ selectValue: v.target.value });
    this.props.passUp(this.props.type, v.target.value);
  }
  handleChangeMultiple = (event) => {
    const { options } = event.target;
    const value = [];
    for (let i = 0, l = options.length; i < l; i += 1) {
      if (options[i].selected) {
        value.push(options[i].value);
      }
    }

    this.setState({ selectValue: value });
    this.props.passUp(this.props.type, value);
  };
  render() {
    const { type, multiple, select_all } = this.props;
    const { loading, list } = this.state;
    return !loading ? (
      <>
        <Select
          native
          fullWidth={true}
          multiple={multiple}
          value={this.state.selectValue}
          renderValue={(selected) => selected.join(', ')}
          onChange={multiple ? this.handleChangeMultiple : this.selectValue}
          className={multiple ? 'tallList' : ''}
          displayEmpty={multiple ? true : false}
          input={
            <OutlinedInput
              name=""
              labelWidth={this.props.labelWidth ? this.props.labelWidth : 125}
            />
          }
        >
          {multiple && !select_all ? (
            <></>
          ) : (
            <option value={'all'}>
              {'All ' +
                type.replace(/_/g, ' ').replace(/\w\S*/g, function (txt) {
                  return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
                })}
            </option>
          )}

          {list.length > 0 &&
            list.map((item) =>
              type === 'locations' ? (
                <option
                  key={item.id}
                  value={item.id}
                >
                  {item.name != null ? item.name + ' - ' : ''}
                  {item.address_1 != null ? item.address_1 + ' - ' : ''}
                  {item.city != null ? item.city + ', ' : ''}
                  {item.state}
                </option>
              ) : (
                <option
                  key={item.id}
                  value={item.id}
                >
                  {item.name != null ? item.name : ''}
                </option>
              ),
            )}
        </Select>
      </>
    ) : (
      <>
        <LinearProgress
          color="primary"
          style={{ width: '33%', display: 'block', textAlign: 'center', margin: '45px auto 0px auto' }}
        />
      </>
    );
  }
}

export default DelayedSelect;
